module.exports = require("chokidar");


//////////////////
// WEBPACK FOOTER
// external "chokidar"
// module id = 33
// module chunks = 0